import { OfficeWebAppOpenTarget } from "client/Api/Documents/SharePoint/common";
import { environmentHttpClient } from "client/Api/httpClient";
import {
	DocumentActionConditionalAccessSettingsSaveModel,
	DocumentActionConditionalAccessSettingsModel,
	OfficeDocumentEditor
} from "client/Api/Documents/common";
import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";

export type WebDavSettingsModel = {
	webDavServers: WebDavServerModel[];
	openDocumentSettings: WebDavOpenDocumentSettingsModel;
};

export type WebDavServerModel = {
	id?: number;
	name: string;
	url: string;
};

export type WebDavOpenDocumentSettingsModel = {
	openOnlineConfigured: boolean;
	openLocalEnabled: boolean;
	openOnlineEnabled: boolean;
	defaultOfficeDocumentEditor: OfficeDocumentEditor;
	onlineEditorsOpenTarget: OfficeWebAppOpenTarget;
	openLocalConditionalAccessSettings: DocumentActionConditionalAccessSettingsModel;
	openLocalPermissions: WebDavDocumentPermissionsModel;
};

export type WebDavDocumentPermissionsModel = {
	everyoneHasAccess: boolean;
	userIds: number[];
	userGroupIds: number[];
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export type WebDavSettingsSaveModel = {
	webDavServers: WebDavServerModel[];
	openDocumentSettings: WebDavOpenDocumentSettingsSaveModel;
};

export type WebDavOpenDocumentSettingsSaveModel = {
	openLocalEnabled: boolean;
	openOnlineEnabled: boolean;
	defaultOfficeDocumentEditor: OfficeDocumentEditor;
	onlineEditorsOpenTarget: OfficeWebAppOpenTarget;
	openLocalConditionalAccessSettings: DocumentActionConditionalAccessSettingsSaveModel;
	openLocalPermissions: SaveWebDavDocumentPermissionsModel;
};

export type SaveWebDavDocumentPermissionsModel = {
	everyoneHasAccess: boolean;
	userIds: number[];
	userGroupIds: number[];
};

export type SaveSettingsSuccessfulResponseModel = {
	webDavServers: WebDavServerModel[];
};

export function fetchWebDavModels(signal?: AbortSignal): Promise<WebDavSettingsModel> {
	return environmentHttpClient.get<WebDavSettingsModel>(
		"UiApi/WebDavSettings",
		undefined,
		{ signal }
	);
}

export function save(
	saveModel: WebDavSettingsSaveModel,
	signal?: AbortSignal
): Promise<SaveSettingsSuccessfulResponseModel> {
	return environmentHttpClient.put<SaveSettingsSuccessfulResponseModel>(
		"UiApi/WebDavSettings",
		saveModel,
		{ signal }
	);
}
